// extracted by mini-css-extract-plugin
export var attachment = "_rc-a";
export var emailContainer = "_rc-4";
export var emailContentPaddedContainer = "_rc-b";
export var emailHeader = "_rc-6";
export var emailIframe = "_rc-3";
export var emailInfoIcon = "_rc-9";
export var emailShortenedSummary = "_rc-e";
export var infoDropdown = "_rc-0";
export var infoRowBoundedContent = "_rc-d";
export var internal = "_rc-5";
export var merchant = "_rc-8";
export var messageInputContainer = "_rc-h";
export var normal = "_rc-7";
export var replyCard = "_rc-f";
export var subtleButton = "_rc-1";
export var subtleButtonIconContainer = "_rc-2";
export var toggleViewRepliesButton = "_rc-c";
export var wrappingText = "_rc-g";